import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useReactToPrint } from 'react-to-print';
import {useLocation} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ContentTitle } from '../../ui/styled';
import { Auth } from 'aws-amplify';
import BackIcon from '../../common/Back/BackIcon';
import PageHeading from '../../common/Heading/PageHeading';
import { getCompletionList } from '../../Authorization/services/authorizationsApi';
import { dateFormatShort } from '../../../constants';
import moment from 'moment';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { LeftGrid } from '../../Episode/Episode.Styled';
import Button from '@mui/material/Button';

const CompletionRatioFunding = (props) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });
  const location = useLocation();
  console.log(location.state);
  const filter = location.state.commonParams.split('&')[1].replace(':undefined|', '');
  const variant = location.state.variant;
  console.log(variant);
  
  
  const [user, setUser] = useState(null);
  const [dataList, setDataList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1, 
    pageSize: 10,
  });
  const [reportGroups, setReportGroups] = useState([]);

  let totSuccessful = 0;
  let totParticipants = 0;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    const commonParams = location.state.commonParams
    setDataList((prveState) => ({ ...prveState, isLoading: true }));
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const report = await getCompletionList({
      commonParams,
      authorization,
    });
    //console.log('report.data')
    //console.log(report.data)

    let builder = [];
    const authTypes = groupItems(report.data, 'sapathAthTypId');
    //console.log('authTypes')
    //console.log(authTypes)

    for (var auth in authTypes) {
      //console.log(auth)
      //console.log(authTypes[auth])
      builder.push(
        {
          authType: auth,
          items: authTypes[auth]
        }
      )
    }
    console.log('builder');
    console.log(builder);
    setReportGroups(builder);


    setDataList((prveState) => ({
      ...prveState,
      ...report,
    }));
  };

  const groupItems = (array, property) => {
    var reducer = function(groups, item) {
        var name = item[property]
        var group = groups[name] || (groups[name] = []);
        group.push(item);
        return groups;
    };
    return array.reduce(reducer, {});
  }
  
  return (
    <>
      <ContentTitle container>
        <Grid item xs={6}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Directory' />
          </Box>
        </Grid>
        <LeftGrid item xs={6}>
          <Button
            variant='contained'
            style={{ justifyContent: 'flex-end' }}
            onClick={() => handlePrint()}
          >
            Print
          </Button>
        </LeftGrid>
      </ContentTitle>
      <Box px={4} ref={componentRef}>  
      <Grid item xs={12}>
        <Box p={2} style={{ alignItems: 'center' }}>
          <Typography variant='h4' align='center'>Completion Ratio by Funding Source</Typography>
          <Typography variant='h6' align='center'>{filter}</Typography>
        </Box>
      </Grid>

          
            {reportGroups.map((row, index) => {
              let subSuccessful = 0;
              return (
              <Fragment key={index}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow
                      sx={{backgroundColor: '#000'}}
                    >
                      <TableCell sx={{color: '#fff'}}>Participant</TableCell>
                      <TableCell sx={{color: '#fff'}}>Gnd</TableCell>
                      <TableCell sx={{color: '#fff'}}>CDC #</TableCell>
                      <TableCell sx={{color: '#fff'}}>290</TableCell>
                      <TableCell sx={{color: '#fff'}}>CCC MS</TableCell>
                      <TableCell sx={{color: '#fff'}}>Ref Source</TableCell>
                      <TableCell sx={{color: '#fff'}}>Admit</TableCell>
                      <TableCell sx={{color: '#fff'}}>Discharge</TableCell>
                      <TableCell sx={{color: '#fff'}}>Reason</TableCell>
                      <TableCell sx={{color: '#fff'}}>Successful</TableCell>
                      <TableCell sx={{color: '#fff'}}>Mod</TableCell>
                      <TableCell sx={{color: '#fff'}}>CBP Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  <TableRow sx={{backgroundColor: '#000'}}
                  >
                    <TableCell colSpan="12" sx={{color: '#fff'}}>{row.authType}</TableCell>
                  </TableRow>
                    {
                      row.items.map((row) => {
                        totParticipants += 1;
                        totSuccessful += row.successful ? 1 : 0;
                        subSuccessful += row.successful ? 1 : 0;
                        return(
                          <TableRow
                            key={totParticipants}
                            sx={{ '&:nth-of-type(odd)': {backgroundColor: '#eee'}, '&:last-child td, &:last-child th': { border: 0} }}
                          >
                            <TableCell component="th" scope="row">
                              {row.prtKey}
                            </TableCell>
                            <TableCell>{row.prtGndId}</TableCell>
                            <TableCell>{row.epdIcnCdc}</TableCell>
                            <TableCell>{row.prt290RegYn ? 'Y' : 'N'}</TableCell>
                            <TableCell>{row.epdPsyCcmsynYn ? 'Y' : 'N'}</TableCell>
                            <TableCell>{row.sapathAthTypId}</TableCell>
                            <TableCell>{moment(row.sapAthAdmDate).format(dateFormatShort)}</TableCell>
                            <TableCell>{moment(row.sapAthDchDate).format(dateFormatShort)}</TableCell>
                            <TableCell>{row.sapAthAthDchTypId}</TableCell>
                            <TableCell>{row.successful ? 'Y' : 'N'}</TableCell>
                            <TableCell>{row.cboModId}</TableCell>
                            <TableCell>{row.cboName}</TableCell>
                          </TableRow>
                        )
                      })

                    }
                      <TableRow 
                        sx={{backgroundColor: '#000'}}
                      >
                        <TableCell colSpan="6" sx={{color: '#fff', fontWeight: '600'}} align="left">
                          {row.items.length}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell sx={{color: '#fff', fontWeight: '600'}}>{subSuccessful}</TableCell>
                        <TableCell></TableCell>
                        <TableCell sx={{color: '#fff', fontWeight: '600'}}>{Math.floor(subSuccessful / row.items.length * 100) + '%'}</TableCell>
                      </TableRow>
                      <TableRow sx={{border: 0}}>
                        <TableCell sx={{border: 0}}></TableCell>
                      </TableRow>
                          </TableBody>
          
                  </Table>
                </TableContainer>
                {index < (reportGroups.length-1) &&
                  <div className="page-break-after" />
                }  

              </Fragment>



              )  




            })}

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                  <TableRow sx={{border: 0}}>
                    <TableCell sx={{border: 0}}></TableCell>
                  </TableRow>
                  <TableRow 
                    sx={{backgroundColor: '#000'}}
                  >
                    <TableCell colSpan="6" sx={{color: '#fff', fontWeight: '600'}} align="left">
                      Total: {totParticipants}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell sx={{color: '#fff', fontWeight: '600'}}>Completed:</TableCell>
                    <TableCell sx={{color: '#fff', fontWeight: '600'}}>{totSuccessful}</TableCell>
                    <TableCell sx={{color: '#fff', fontWeight: '600'}}>Ratio</TableCell>
                    <TableCell sx={{color: '#fff', fontWeight: '600'}}>{Math.floor(totSuccessful / totParticipants * 100) + '%'}</TableCell>
                  </TableRow>
                </TableBody>  
              </Table>
            </TableContainer>  
                

    </Box>

    </>
  );
};
export default CompletionRatioFunding;
